import Details from './addExpert/Details';
import Description from './addExpert/Description';
import Expertise from './addExpert/Expertise';
import { Fragment, useEffect, useState } from 'react';
import Divider from 'components/Divider';
import { useForm } from 'react-hook-form';
import Button from 'components/Button';

import { useDispatch, useSelector } from 'react-redux';
import {
    addExpert,
    addExpertImage,
    expertSelector,
    updateExpert,
} from 'store/company/expert';
import { common } from 'lang/en.json';
import SidescreenHeader from './SidescreenHeader';
import { authSelector } from 'store/auth';

const ExpertSlider = ({ isEdit, onUpdate, title }) => {
    const dispatch = useDispatch();
    const { isAuthorized } = useSelector(authSelector);
    const { loading, data, expert } = useSelector(expertSelector);
    const { register, handleSubmit, errors } = useForm();

    const [picture, setPicture] = useState(null);
    const [picturePreview, setPicturePreview] = useState(null);
    const [expertise, setExpertise] = useState([]);

    const [formData, setFormData] = useState({ details: {} });

    useEffect(() => {
        if (!loading && expert && isEdit) {
            setFormData({
                details: {
                    ...expert,
                },
            });
            setExpertise(expert.expertise);
        }
    }, [expert]);

    const handleDetails = (details) => {
        setFormData({ ...formData, details });
    };

    const handleDescription = (description) => {
        setFormData({ ...formData, description });
    };

    const handleFormSubmit = (e) => {
        expert ? handleUpdateExpert() : handleAddExpert();
    };

    const handleUpdateExpert = async () => {
        await handleFileUpload();
        await dispatch(
            updateExpert({
                ...formData.details,
                bio: formData.description,
                expertise,
            })
        );
        if (onUpdate) {
            onUpdate();
        }
    };

    const handleAddExpert = async () => {
        await dispatch(
            addExpert({
                ...formData.details,
                bio: formData.description,
                expertise,
            })
        );

        await handleFileUpload();
        if (onUpdate) {
            onUpdate('Expert');
        }
    };

    const handleFile = (file) => {
        setPicture(file.file);
        setPicturePreview(file.src);
    };

    const handleFileUpload = async () => {
        if (!picture) {
            if (onUpdate) {
                return onUpdate();
            }
            return null;
        }

        const formData = new FormData();
        formData.append('image', picture);

        await dispatch(addExpertImage(formData));

        if (!loading && onUpdate) {
            onUpdate();
        }
        setPicturePreview(null);
    };

    const preTitle = isEdit ? 'Edit' : 'Add';

    return (
        <Fragment>
            <form onSubmit={handleSubmit(handleFormSubmit)} autoComplete="off">
                <SidescreenHeader
                    title={isAuthorized ? `${preTitle} ${title}` : title}
                    isAuthorized={isAuthorized}
                    isEditable={isEdit}
                />

                <Details
                    callback={handleDetails}
                    register={register}
                    errors={errors}
                    data={expert ? expert : formData.details}
                    handleFile={handleFile}
                    picturePreview={picturePreview}
                    isEditable={isEdit}
                    experts={data}
                />

                <Divider />

                <Description
                    callback={handleDescription}
                    register={register}
                    errors={errors}
                    description={expert ? expert.bio : formData.details.bio}
                />

                <Divider />

                <Expertise data={[...expertise]} update={setExpertise} />

                {isAuthorized && (
                    <>
                        <Divider />

                        <Button
                            title={common.save}
                            loading={loading}
                            sticky={{ position: 'bottom' }}
                        />
                    </>
                )}
            </form>
        </Fragment>
    );
};

export default ExpertSlider;
